import type {RecommendationsResponse} from '@/api/bffHotel';
import type {
  RecoInfo,
  Recommendation,
} from '@/modules/common/hooks/useRecommendations/models';
import type {Price} from '@/redux/v1/models';
import type {HotelCategoryType} from '@travel-frontend/ui-components';

import {is} from 'valibot';

import {RecoInfoSchema} from '@/modules/common/hooks/useRecommendations/models';
import {priceFormat} from '@/utils/numberFormat';

const isPriceObject = (price?: {
  amount?: number;
  currency?: string;
}): price is Price =>
  price != null &&
  typeof price.amount === 'number' &&
  typeof price.currency === 'string';

/**
 * currently needed since the response only holds optional fields
 * ideally this needs to be fixed in the swagger.json by the backend
 */

export const mapResponseToRecommendation = (
  {hotels, info, translations = {}}: RecommendationsResponse,
  pax: number
) => {
  let recoInfo: null | RecoInfo = null;

  try {
    const recoInfoTemporary = JSON.parse(info ?? '', (_key, value) => {
      if (value === 'true' || value === 'false') {
        return Boolean(value);
      }
      return value;
    });

    if (is(RecoInfoSchema, recoInfoTemporary)) {
      recoInfo = recoInfoTemporary;
    }
  } catch {
    // couldn't parse
  }

  return hotels.reduce<Array<Recommendation>>((accumulator, hotel) => {
    const {
      category,
      catering,
      city,
      duration,
      hotelID,
      link,
      name,
      priceDisplay,
      region,
      teaserImage,
    } = hotel;

    // a recommendation without those attributes are considered to be not a recommendation
    if (
      !hotelID ||
      !category ||
      !category.type ||
      !category.value ||
      !name ||
      !teaserImage ||
      !link ||
      !duration
    ) {
      return accumulator;
    }

    if (!isPriceObject(priceDisplay)) {
      return accumulator;
    }

    accumulator.push({
      hotelId: hotelID,
      category: {
        type: category.type as HotelCategoryType,
        value: category.value,
      },
      formattedPrice: priceFormat(priceDisplay),
      price: priceDisplay.amount,
      hotelName: name,
      image: teaserImage,
      boardType: catering?.code ? translations[catering.code] : undefined,
      link,
      travelDuration: duration,
      pax,
      city,
      region,
      index: hotels.indexOf(hotel),
      recoInfo,
    });

    return accumulator;
  }, []);
};
